import { createEntityAdapter } from '@reduxjs/toolkit';
import { AttachemntParams } from './attachments.types';

const adapter = createEntityAdapter<AttachemntParams>();

export default adapter;
